export default "__VITE_ASSET__7_dUzcx5__"